module.exports = __webpack_public_path__ + "static/peacock-e7d2457c1019d06793b2aa15a8ce5ac1.jpg";